// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FaFileExcel, FaEdit, FaTrash, FaEye, FaUpload, FaCalendarAlt, FaFilter, FaDownload, FaInfoCircle } from "react-icons/fa";
// import { FiUploadCloud, FiX } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import JSZip from "jszip";

// const DoctorAppointmentList = () => {
//   const [appointments, setAppointments] = useState([]);
//   const [search, setSearch] = useState("");
//   const [editAppointment, setEditAppointment] = useState(null);
//   const [newStatus, setNewStatus] = useState("");
//   const [showReportModal, setShowReportModal] = useState(false);
//   const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
//   const [currentAppointmentId, setCurrentAppointmentId] = useState(null);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [fileInputKey, setFileInputKey] = useState(Date.now());
//   const navigate = useNavigate();

//   // Date filter states
//   const [dateFilter, setDateFilter] = useState("all");
//   const [customStartDate, setCustomStartDate] = useState("");
//   const [customEndDate, setCustomEndDate] = useState("");
//   const [showDateFilter, setShowDateFilter] = useState(false);

//   // Bulk download states
//   const [showDownloadModal, setShowDownloadModal] = useState(false);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [downloadType, setDownloadType] = useState("");
//   const [isDownloading, setIsDownloading] = useState(false);
//   const [downloading, setDownloading] = useState(false);
//   const [downloadProgress, setDownloadProgress] = useState({ done: 0, total: 0, currentFile: "" });

//   // Selection states
//   const [selectedAppointments, setSelectedAppointments] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);

//   // Bulk upload modal (server-side)
//   const [bulkUploadModal, setBulkUploadModal] = useState({
//     show: false,
//     type: 'report',
//     file: null,
//     uploading: false,
//     results: null
//   });

//   // Instructions modal state
//   const [showInstructionsModal, setShowInstructionsModal] = useState(false);

//   const reportFileInputRef = React.useRef(null);
//   const prescriptionFileInputRef = React.useRef(null);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const appointmentsPerPage = 5;

//   useEffect(() => {
//     fetchAppointments();
//   }, []);

//   useEffect(() => {
//     setSelectedAppointments([]);
//     setSelectAll(false);
//     setCurrentPage(1);
//   }, [search, dateFilter, customStartDate, customEndDate]);

//   const fetchAppointments = async () => {
//     try {
//       const res = await axios.get("https://api.elthiumhealth.com/api/admin/alldoctorbookings");
//       if (res.data && res.data.appointments) {
//         const formattedAppointments = res.data.appointments.map(appt => ({
//           ...appt,
//           formattedDate: formatDate(appt.appointment_date)
//         }));
//         setAppointments(formattedAppointments);
//       }
//     } catch (error) {
//       console.error("Failed to fetch doctor appointments:", error);
//     }
//   };

//   const getBookingId = (appt) => {
//     return appt.doctorConsultationBookingId || appt.appointmentId?.toString() || "N/A";
//   };

//   const handleSelectAppointment = (appointmentId) => {
//     setSelectedAppointments(prev =>
//       prev.includes(appointmentId) ? prev.filter(id => id !== appointmentId) : [...prev, appointmentId]
//     );
//   };

//   const handleSelectAll = () => {
//     if (selectAll) {
//       setSelectedAppointments([]);
//     } else {
//       const currentPageIds = currentAppointments.map(appt => appt.appointmentId);
//       setSelectedAppointments(currentPageIds);
//     }
//     setSelectAll(!selectAll);
//   };

//   const handleStatusUpdate = async () => {
//     try {
//       const res = await axios.put(
//         `https://api.elthiumhealth.com/api/admin/updatestatus/${editAppointment.appointmentId}`,
//         { newStatus: newStatus }
//       );
//       if (res.status === 200) {
//         fetchAppointments();
//         setEditAppointment(null);
//         setNewStatus("");
//       }
//     } catch (error) {
//       console.error("Failed to update appointment status:", error);
//     }
//   };

//   const handleDelete = async (id) => {
//     const confirmDelete = window.confirm("Are you sure you want to delete this appointment?");
//     if (!confirmDelete) return;
//     try {
//       await axios.delete(`https://api.elthiumhealth.com/api/admin/deleteappointments/${id}`);
//       setAppointments(appointments.filter((a) => a.appointmentId !== id));
//       alert("Appointment deleted successfully.");
//     } catch (error) {
//       console.error("Failed to delete appointment:", error);
//       alert("Failed to delete appointment. Please try again.");
//     }
//   };

//   const handleFileChange = (e) => setSelectedFile(e.target.files[0]);

//   const handleUploadReport = async () => {
//     if (!selectedFile) return alert("Please select a file first");
//     setUploading(true);
//     const formData = new FormData();
//     formData.append("report", selectedFile);
//     try {
//       const res = await axios.post(
//         `https://api.elthiumhealth.com/api/admin/upload-doctor-report/${currentAppointmentId}`,
//         formData,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );
//       if (res.status === 200) {
//         alert("Report uploaded successfully");
//         fetchAppointments();
//         setShowReportModal(false);
//         setSelectedFile(null);
//         setFileInputKey(Date.now());
//       }
//     } catch (error) {
//       console.error("Error uploading report:", error);
//       alert("Failed to upload report");
//     } finally {
//       setUploading(false);
//     }
//   };

//   const handleUploadPrescription = async () => {
//     if (!selectedFile) return alert("Please select a file first");
//     setUploading(true);
//     const formData = new FormData();
//     formData.append("prescription", selectedFile);
//     try {
//       const res = await axios.post(
//         `https://api.elthiumhealth.com/api/admin/upload-doctor-prescription/${currentAppointmentId}`,
//         formData,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );
//       if (res.status === 200) {
//         alert("Prescription uploaded successfully");
//         fetchAppointments();
//         setShowPrescriptionModal(false);
//         setSelectedFile(null);
//         setFileInputKey(Date.now());
//       }
//     } catch (error) {
//       console.error("Error uploading prescription:", error);
//       alert("Failed to upload prescription");
//     } finally {
//       setUploading(false);
//     }
//   };

//   // Date helpers
//   const isToday = (dateString) => {
//     if (!dateString) return false;
//     const today = new Date();
//     const date = new Date(dateString);
//     return date.getDate() === today.getDate() &&
//       date.getMonth() === today.getMonth() &&
//       date.getFullYear() === today.getFullYear();
//   };
//   const isYesterday = (dateString) => {
//     if (!dateString) return false;
//     const yesterday = new Date();
//     yesterday.setDate(yesterday.getDate() - 1);
//     const date = new Date(dateString);
//     return date.getDate() === yesterday.getDate() &&
//       date.getMonth() === yesterday.getMonth() &&
//       date.getFullYear() === yesterday.getFullYear();
//   };
//   const isThisMonth = (dateString) => {
//     if (!dateString) return false;
//     const today = new Date();
//     const date = new Date(dateString);
//     return date.getMonth() === today.getMonth() &&
//       date.getFullYear() === today.getFullYear();
//   };
//   const isInDateRange = (dateString, startDate, endDate) => {
//     if (!dateString || !startDate || !endDate) return false;
//     const date = new Date(dateString);
//     const start = new Date(startDate);
//     const end = new Date(endDate);
//     end.setHours(23, 59, 59, 999);
//     return date >= start && date <= end;
//   };

//   const filterByDate = (appt) => {
//     if (dateFilter === "all") return true;
//     if (dateFilter === "today") return isToday(appt.appointment_date);
//     if (dateFilter === "yesterday") return isYesterday(appt.appointment_date);
//     if (dateFilter === "thisMonth") return isThisMonth(appt.appointment_date);
//     if (dateFilter === "custom") return isInDateRange(appt.appointment_date, customStartDate, customEndDate);
//     return true;
//   };

//   const filteredAppointments = appointments
//     .filter(filterByDate)
//     .filter((appt) => {
//       const searchTerm = search.toLowerCase();
//       return (
//         appt.doctor_name?.toLowerCase()?.includes(searchTerm) ||
//         appt.staff_name?.toLowerCase()?.includes(searchTerm) ||
//         appt.staff_employeeId?.toLowerCase()?.includes(searchTerm) ||
//         appt.doctorConsultationBookingId?.toLowerCase()?.includes(searchTerm) ||
//         appt.patient_name?.toLowerCase()?.includes(searchTerm)
//       );
//     });

//   const indexOfLastAppointment = currentPage * appointmentsPerPage;
//   const indexOfFirstAppointment = indexOfLastAppointment - appointmentsPerPage;
//   const currentAppointments = filteredAppointments.slice(indexOfFirstAppointment, indexOfLastAppointment);
//   const totalPages = Math.ceil(filteredAppointments.length / appointmentsPerPage);

//   const exportToExcel = () => {
//     const dataToExport = filteredAppointments.map(appt => ({
//       "Booking ID": getBookingId(appt),
//       "Doctor": appt.doctor_name || 'N/A',
//       "Specialization": appt.doctor_specialization || 'N/A',
//       "User": appt.staff_name || 'N/A',
//       "Employee ID": appt.staff_employeeId || 'N/A',
//       "Type": appt.consultation_type || 'N/A',
//       "Date": appt.formattedDate || 'N/A',
//       "Time": appt.time_slot || 'N/A',
//       "Paid": `₹${appt.payable_amount || '0'}`,
//       "Status": appt.status || 'N/A',
//       "Report": appt.doctorReports ? 'Yes' : 'No',
//       "Prescription": appt.doctorPrescriptions ? 'Yes' : 'No',
//       "Meeting Link": appt.meeting_link ? 'Yes' : 'No'
//     }));
//     const worksheet = XLSX.utils.json_to_sheet(dataToExport);
//     worksheet['!cols'] = [
//       { wch: 12 }, { wch: 18 }, { wch: 18 }, { wch: 12 }, { wch: 12 },
//       { wch: 8 }, { wch: 10 }, { wch: 10 }, { wch: 8 }, { wch: 10 },
//       { wch: 8 }, { wch: 10 }, { wch: 12 }
//     ];
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Appointments");
//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
//     saveAs(blob, "doctor_appointments.xlsx");
//   };

//   const formatDate = (dateString) => {
//     try {
//       if (!dateString) return "N/A";
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return "Invalid date";
//       return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
//     } catch {
//       return "Invalid date";
//     }
//   };

//   const openReportModal = (appointmentId) => {
//     setCurrentAppointmentId(appointmentId);
//     setShowReportModal(true);
//     setSelectedFile(null);
//     setFileInputKey(Date.now());
//   };

//   const openPrescriptionModal = (appointmentId) => {
//     setCurrentAppointmentId(appointmentId);
//     setShowPrescriptionModal(true);
//     setSelectedFile(null);
//     setFileInputKey(Date.now());
//   };

//   const triggerFileInput = (type) => {
//     if (type === 'report') reportFileInputRef.current.click();
//     else if (type === 'prescription') prescriptionFileInputRef.current.click();
//   };

//   const countAppointmentsByDateFilter = (filterType) => {
//     if (filterType === "all") return appointments.length;
//     if (filterType === "today") return appointments.filter(a => isToday(a.appointment_date)).length;
//     if (filterType === "yesterday") return appointments.filter(a => isYesterday(a.appointment_date)).length;
//     if (filterType === "thisMonth") return appointments.filter(a => isThisMonth(a.appointment_date)).length;
//     if (filterType === "custom") return appointments.filter(a => isInDateRange(a.appointment_date, customStartDate, customEndDate)).length;
//     return 0;
//   };

//   const handleCustomDateSelect = () => {
//     if (customStartDate && customEndDate) setDateFilter("custom");
//   };

//   useEffect(() => {
//     if (dateFilter !== "custom") {
//       setCustomStartDate("");
//       setCustomEndDate("");
//     }
//   }, [dateFilter]);

//   const [showMeetingLinkModal, setShowMeetingLinkModal] = useState(false);
//   const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
//   const [newMeetingLink, setNewMeetingLink] = useState("");

//   const openMeetingLinkModal = (appointmentId) => {
//     setSelectedAppointmentId(appointmentId);
//     setNewMeetingLink("");
//     setShowMeetingLinkModal(true);
//   };
//   const closeMeetingLinkModal = () => {
//     setShowMeetingLinkModal(false);
//     setSelectedAppointmentId(null);
//     setNewMeetingLink("");
//   };
//   const handleMeetingLinkSubmit = async () => {
//     if (!newMeetingLink.trim()) return alert("Please enter a valid meeting link.");
//     try {
//       const response = await fetch(`https://api.elthiumhealth.com/api/admin/updatemeetinglink/${selectedAppointmentId}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ meeting_link: newMeetingLink.trim() }),
//       });
//       if (!response.ok) throw new Error("Failed to update meeting link");
//       alert("Meeting link updated successfully!");
//       closeMeetingLinkModal();
//       fetchAppointments();
//     } catch (error) {
//       alert("Error updating meeting link: " + error.message);
//     }
//   };

//   // Bulk download (date-range) – unchanged
//   const bulkDownload = async (type) => {
//     if (!customStartDate || !customEndDate) {
//       alert("Please select a start and end date for the booking date range first.");
//       return;
//     }
//     const apptsInRange = appointments.filter(a => isInDateRange(a.appointment_date, customStartDate, customEndDate));
//     if (!apptsInRange.length) {
//       alert("No appointments found in the selected date range.");
//       return;
//     }
//     const zip = new JSZip();
//     const filesToFetch = [];
//     const extractUrls = (field) => {
//       if (!field) return [];
//       if (typeof field === "string") return [field];
//       if (Array.isArray(field)) {
//         return field.flatMap(item => {
//           if (!item) return [];
//           if (typeof item === "string") return [item];
//           if (typeof item === "object") return [item.url || item.file || item.path || item.location].filter(Boolean);
//           return [];
//         });
//       }
//       if (typeof field === "object") return [field.url || field.file || field.path || field.location].filter(Boolean);
//       return [];
//     };
//     for (const appt of apptsInRange) {
//       const bookingId = getBookingId(appt);
//       if (type === "report" || type === "both") {
//         const reportUrls = extractUrls(appt.doctorReports);
//         reportUrls.forEach((url, idx) => {
//           filesToFetch.push({ url, filename: `${bookingId}_report_${idx + 1}${getFileExtensionFromUrl(url)}` });
//         });
//       }
//       if (type === "prescription" || type === "both") {
//         const presUrls = extractUrls(appt.doctorPrescriptions);
//         presUrls.forEach((url, idx) => {
//           filesToFetch.push({ url, filename: `${bookingId}_prescription_${idx + 1}${getFileExtensionFromUrl(url)}` });
//         });
//       }
//     }
//     if (!filesToFetch.length) {
//       alert("No files found for the selected type(s) in this date range.");
//       return;
//     }
//     setDownloading(true);
//     setDownloadProgress({ done: 0, total: filesToFetch.length, currentFile: "" });
//     let done = 0;
//     for (const fileObj of filesToFetch) {
//       const { url, filename } = fileObj;
//       setDownloadProgress(p => ({ ...p, currentFile: filename }));
//       try {
//         const response = await fetch(url);
//         if (!response.ok) {
//           zip.file(`${filename}.ERROR.txt`, `Failed to fetch: ${url}\nStatus: ${response.status}`);
//         } else {
//           const blob = await response.blob();
//           zip.file(filename, blob);
//         }
//       } catch (err) {
//         zip.file(`${filename}.ERROR.txt`, `Error: ${err.message}`);
//       }
//       done++;
//       setDownloadProgress(p => ({ ...p, done }));
//     }
//     try {
//       const outName = `doctor_${type}_${customStartDate}_to_${customEndDate}.zip`;
//       const content = await zip.generateAsync({ type: "blob" });
//       saveAs(content, outName);
//     } catch (err) {
//       alert("Failed to create ZIP: " + err.message);
//     } finally {
//       setDownloading(false);
//       setDownloadProgress({ done: 0, total: 0, currentFile: "" });
//     }
//   };

//   function getFileExtensionFromUrl(url) {
//     try {
//       const parsed = url.split("?")[0].split("#")[0];
//       const lastDot = parsed.lastIndexOf(".");
//       if (lastDot === -1) return ".bin";
//       const ext = parsed.slice(lastDot);
//       return ext.length > 1 && ext.length <= 6 ? ext : ".bin";
//     } catch {
//       return ".bin";
//     }
//   }

//   const handleBulkDownloadModal = () => {
//     if (!downloadType || !startDate || !endDate) return;
//     setIsDownloading(true);
//     (async () => {
//       try {
//         const zip = new JSZip();
//         const filteredAppointments = appointments.filter(appt => {
//           const appointmentDate = new Date(appt.appointment_date);
//           const start = new Date(startDate);
//           const end = new Date(endDate);
//           end.setHours(23, 59, 59);
//           return appointmentDate >= start && appointmentDate <= end;
//         });
//         let fileCount = 0;
//         for (const appt of filteredAppointments) {
//           const files = downloadType === "reports" ? appt.doctorReports : appt.doctorPrescriptions;
//           if (files && files.length) {
//             for (let i = 0; i < files.length; i++) {
//               try {
//                 const response = await axios.get(`https://api.elthiumhealth.com${files[i]}`, { responseType: 'blob' });
//                 const fileName = `${appt.staff_name}_${downloadType.slice(0, -1)}_${i+1}_${appt.appointment_date}.pdf`;
//                 zip.file(fileName, response.data);
//                 fileCount++;
//               } catch (error) {
//                 console.error(`Failed to download: ${files[i]}`, error);
//               }
//             }
//           }
//         }
//         if (fileCount > 0) {
//           const content = await zip.generateAsync({ type: "blob" });
//           saveAs(content, `${downloadType}_${startDate}_to_${endDate}.zip`);
//           alert(`✅ ${fileCount} files downloaded!`);
//         } else {
//           alert("❌ No files found.");
//         }
//       } catch (error) {
//         console.error("Download failed:", error);
//         alert("❌ Download failed.");
//       } finally {
//         setIsDownloading(false);
//         setShowDownloadModal(false);
//       }
//     })();
//   };

//   // ==================== BULK UPLOAD (SERVER-SIDE) ====================
//   const openBulkUploadModal = () => {
//     if (selectedAppointments.length === 0) {
//       alert("Please select at least one appointment to upload files.");
//       return;
//     }
//     setBulkUploadModal({
//       show: true,
//       type: 'report',
//       file: null,
//       uploading: false,
//       results: null
//     });
//   };

//   const handleBulkZipChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.name.endsWith('.zip')) {
//       setBulkUploadModal(prev => ({ ...prev, file }));
//     } else {
//       alert('Please select a valid ZIP file');
//       e.target.value = '';
//     }
//   };

//   const handleBulkUpload = async () => {
//     if (!bulkUploadModal.file) return alert('Please select a ZIP file first');

//     setBulkUploadModal(prev => ({ ...prev, uploading: true, results: null }));

//     const formData = new FormData();
//     formData.append('zipFile', bulkUploadModal.file);

//     try {
//       const response = await axios.post(
//         `https://api.elthiumhealth.com/api/admin/bulk-upload-doctor?type=${bulkUploadModal.type}`,
//         formData,
//         { headers: { 'Content-Type': 'multipart/form-data' } }
//       );

//       if (response.data.success) {
//         setBulkUploadModal(prev => ({
//           ...prev,
//           uploading: false,
//           results: response.data.results
//         }));
//         alert(`Bulk upload finished!\nSuccessful: ${response.data.results.success}\nFailed: ${response.data.results.failed.length}`);
//         if (response.data.results.success > 0) fetchAppointments();
//       } else {
//         throw new Error(response.data.message);
//       }
//     } catch (error) {
//       console.error("Bulk upload error:", error);
//       setBulkUploadModal(prev => ({
//         ...prev,
//         uploading: false,
//         results: { total: 1, success: 0, failed: [{ file: 'ZIP', reason: error.message }] }
//       }));
//       alert("Error during bulk upload. Check console.");
//     } finally {
//       document.getElementById('bulk-zip-input').value = '';
//     }
//   };

//   const closeBulkUploadModal = () => {
//     setBulkUploadModal({
//       show: false,
//       type: 'report',
//       file: null,
//       uploading: false,
//       results: null
//     });
//   };
//   // ==================== END BULK UPLOAD ====================

//   return (
//     <div className="p-4 bg-white rounded shadow">
//       {/* Header */}
//       <div className="flex flex-wrap justify-between items-center gap-2 mb-4">
//         <h2 className="text-xl font-semibold">Doctor Appointments</h2>
//         <div className="flex gap-2">
//           <button
//             onClick={() => setShowInstructionsModal(true)}
//             className="px-4 py-2 bg-gray-500 text-white rounded text-sm flex items-center gap-2 hover:bg-gray-600"
//             title="Bulk Upload Instructions"
//           >
//             <FaInfoCircle /> Instructions
//           </button>
//           <button
//             onClick={openBulkUploadModal}
//             className="px-4 py-2 bg-purple-600 text-white rounded text-sm flex items-center gap-2 hover:bg-purple-700"
//           >
//             <FaUpload /> Bulk Upload ({selectedAppointments.length})
//           </button>
//         </div>
//       </div>

//       {/* Instructions Modal */}
//       {showInstructionsModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white p-6 rounded shadow-md w-[600px] max-w-[90vw] max-h-[80vh] overflow-auto">
//             <h3 className="text-lg font-semibold mb-4">📋 Bulk Upload Instructions</h3>
//             <div className="space-y-3 text-sm">
//               <div className="bg-blue-50 p-3 rounded">
//                 <p className="font-semibold text-blue-800">Step 1: Select Appointments</p>
//                 <p>✅ Use the checkboxes in the table to select the appointments for which you want to upload reports or prescriptions.</p>
//               </div>
//               <div className="bg-blue-50 p-3 rounded">
//                 <p className="font-semibold text-blue-800">Step 2: Prepare ZIP File</p>
//                 <p>📦 Create a ZIP file containing all the files you want to upload.</p>
//                 <p className="mt-1"><strong>⚠️ Important:</strong> Each file inside the ZIP must be named exactly as the <strong>Booking ID</strong> shown in the table (e.g., <code>DOC12345.pdf</code> or <code>DOC12345.jpg</code>).</p>
//                 <p className="mt-1">Supported file types: PDF, DOC, DOCX, JPG, JPEG, PNG.</p>
//               </div>
//               <div className="bg-blue-50 p-3 rounded">
//                 <p className="font-semibold text-blue-800">Step 3: Upload</p>
//                 <p>🔘 Click on <strong>"Bulk Upload"</strong> button (it shows the number of selected appointments).</p>
//                 <p>🔘 In the popup, choose the type (<strong>Reports</strong> or <strong>Prescriptions</strong>).</p>
//                 <p>🔘 Select your prepared ZIP file.</p>
//                 <p>🔘 Click <strong>"Start Upload"</strong>.</p>
//               </div>
//               <div className="bg-blue-50 p-3 rounded">
//                 <p className="font-semibold text-blue-800">Step 4: Monitor Progress</p>
//                 <p>⏳ The upload will start. You will see a progress bar and a final summary of successful and failed files.</p>
//                 <p>📁 After successful upload, the table will refresh and you will see the uploaded files (Download links appear).</p>
//               </div>
//               <div className="bg-yellow-50 p-3 rounded">
//                 <p className="font-semibold text-yellow-800">💡 Tips:</p>
//                 <ul className="list-disc list-inside space-y-1">
//                   <li>Only files that match the Booking ID of a <strong>selected appointment</strong> will be uploaded.</li>
//                   <li>If a file name does not match any selected appointment, it will be skipped and shown in the failed list.</li>
//                   <li>You can upload reports and prescriptions separately – use the type selector in the modal.</li>
//                   <li>Maximum ZIP size depends on server configuration (typically 20-50 MB).</li>
//                 </ul>
//               </div>
//             </div>
//             <div className="flex justify-end mt-4">
//               <button
//                 onClick={() => setShowInstructionsModal(false)}
//                 className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//               >
//                 Got it
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Date Filter Section */}
//       <div className="mb-4 p-4 bg-gray-50 rounded-lg">
//         <div className="flex justify-between items-center mb-3 flex-wrap gap-2">
//           <h3 className="font-medium flex items-center gap-2">
//             <FaFilter className="text-blue-500" /> Filter Appointments by Date
//           </h3>
//           <button
//             onClick={() => setShowDateFilter(!showDateFilter)}
//             className="px-3 py-1 bg-gray-200 rounded text-sm flex items-center gap-1"
//           >
//             <FaCalendarAlt /> {showDateFilter ? 'Hide Filters' : 'Show Filters'}
//           </button>
//         </div>
//         {showDateFilter && (
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
//             <div className={`p-3 rounded cursor-pointer text-center ${dateFilter === "all" ? "bg-blue-100 border border-blue-300" : "bg-white border"}`} onClick={() => setDateFilter("all")}>
//               <div className="font-semibold">All</div>
//               <div className="text-sm text-gray-600">{countAppointmentsByDateFilter("all")} appointments</div>
//             </div>
//             <div className={`p-3 rounded cursor-pointer text-center ${dateFilter === "today" ? "bg-blue-100 border border-blue-300" : "bg-white border"}`} onClick={() => setDateFilter("today")}>
//               <div className="font-semibold">Today</div>
//               <div className="text-sm text-gray-600">{countAppointmentsByDateFilter("today")} appointments</div>
//             </div>
//             <div className={`p-3 rounded cursor-pointer text-center ${dateFilter === "yesterday" ? "bg-blue-100 border border-blue-300" : "bg-white border"}`} onClick={() => setDateFilter("yesterday")}>
//               <div className="font-semibold">Yesterday</div>
//               <div className="text-sm text-gray-600">{countAppointmentsByDateFilter("yesterday")} appointments</div>
//             </div>
//             <div className={`p-3 rounded cursor-pointer text-center ${dateFilter === "thisMonth" ? "bg-blue-100 border border-blue-300" : "bg-white border"}`} onClick={() => setDateFilter("thisMonth")}>
//               <div className="font-semibold">This Month</div>
//               <div className="text-sm text-gray-600">{countAppointmentsByDateFilter("thisMonth")} appointments</div>
//             </div>
//             <div className={`p-3 rounded text-center ${dateFilter === "custom" ? "bg-blue-100 border border-blue-300" : "bg-white border"}`}>
//               <div className="font-semibold mb-2">Custom Range</div>
//               <div className="flex flex-col gap-2">
//                 <input type="date" className="text-sm p-1 border rounded" value={customStartDate} onChange={(e) => setCustomStartDate(e.target.value)} onClick={() => setDateFilter("custom")} />
//                 <input type="date" className="text-sm p-1 border rounded" value={customEndDate} onChange={(e) => setCustomEndDate(e.target.value)} onClick={() => setDateFilter("custom")} />
//                 <div className="flex gap-2">
//                   <button className="text-xs bg-blue-500 text-white py-1 rounded" onClick={handleCustomDateSelect}>Apply</button>
//                   <button className="text-xs bg-gray-200 text-gray-800 py-1 rounded" onClick={() => { setCustomStartDate(""); setCustomEndDate(""); setDateFilter("all"); }}>Clear</button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//         {dateFilter === "custom" && customStartDate && customEndDate && (
//           <div className="mt-3 text-sm text-blue-600">Showing appointments from {customStartDate} to {customEndDate}: {countAppointmentsByDateFilter("custom")} appointments</div>
//         )}
//         <div className="mt-3 flex flex-wrap gap-2 items-center">
//           <button onClick={() => bulkDownload("report")} className="px-3 py-2 bg-green-600 text-white rounded text-sm" disabled={downloading || !customStartDate || !customEndDate}>Download Reports (ZIP)</button>
//           <button onClick={() => bulkDownload("prescription")} className="px-3 py-2 bg-indigo-600 text-white rounded text-sm" disabled={downloading || !customStartDate || !customEndDate}>Download Prescriptions (ZIP)</button>
//           <button onClick={() => bulkDownload("both")} className="px-3 py-2 bg-blue-600 text-white rounded text-sm" disabled={downloading || !customStartDate || !customEndDate}>Download Both (ZIP)</button>
//           {downloading && <div className="ml-4 text-sm text-gray-700">Downloading {downloadProgress.done}/{downloadProgress.total} — {downloadProgress.currentFile}</div>}
//         </div>
//       </div>

//       {/* Search and Export */}
//       <div className="mb-4 flex flex-wrap gap-2">
//         <input type="text" className="px-3 py-2 border rounded text-sm flex-grow min-w-[200px]" placeholder="Search by doctor name, ID, user or employee ID..." value={search} onChange={(e) => setSearch(e.target.value)} />
//         <button onClick={() => setShowDownloadModal(true)} className="px-4 py-2 bg-purple-500 text-white rounded text-sm flex items-center gap-1 hover:bg-purple-600"><FaDownload /> Bulk Download</button>
//         <button onClick={exportToExcel} className="px-4 py-2 bg-green-600 text-white rounded text-sm flex items-center gap-1"><FaFileExcel /> Export</button>
//       </div>

//       {/* Table - compact column widths */}
//       <div className="overflow-x-auto">
//         <table className="w-full border rounded text-sm">
//           <thead className="bg-gray-100">
//             <tr>
//               <th className="p-2 border text-center w-8">
//                 <input type="checkbox" checked={selectAll} onChange={handleSelectAll} className="h-4 w-4 cursor-pointer" />
//               </th>
//               <th className="p-2 border text-left w-24">Booking ID</th>
//               <th className="p-2 border text-left w-28">Doctor</th>
//               <th className="p-2 border text-left w-28">Specialization</th>
//               <th className="p-2 border text-left w-20">User</th>
//               <th className="p-2 border text-left w-20">Emp ID</th>
//               <th className="p-2 border text-left w-16">Type</th>
//               <th className="p-2 border text-left w-24">Date</th>
//               <th className="p-2 border text-left w-16">Time</th>
//               <th className="p-2 border text-left w-12">Paid</th>
//               <th className="p-2 border text-left w-20">Status</th>
//               <th className="p-2 border text-left w-16">Actions</th>
//               <th className="p-2 border text-left w-16">Report</th>
//               <th className="p-2 border text-left w-20">Prescription</th>
//               <th className="p-2 border text-left w-24">Meeting Link</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentAppointments.length > 0 ? (
//               currentAppointments.map((appt) => (
//                 <tr key={appt.appointmentId} className="hover:bg-gray-50 border-b">
//                   <td className="p-2 border text-center">
//                     <input
//                       type="checkbox"
//                       checked={selectedAppointments.includes(appt.appointmentId)}
//                       onChange={() => handleSelectAppointment(appt.appointmentId)}
//                       className="h-4 w-4 cursor-pointer"
//                     />
//                   </td>
//                   <td className="p-2 border truncate max-w-[120px]" title={getBookingId(appt)}>{getBookingId(appt)}</td>
//                   <td className="p-2 border truncate max-w-[140px]" title={appt.doctor_name}>{appt.doctor_name || 'Doctor'}</td>
//                   <td className="p-2 border truncate max-w-[140px]" title={appt.doctor_specialization}>{appt.doctor_specialization || 'N/A'}</td>
//                   <td className="p-2 border truncate max-w-[100px]" title={appt.staff_name}>{appt.staff_name}</td>
//                   <td className="p-2 border">{appt.staff_employeeId || 'null'}</td>
//                   <td className="p-2 border">{appt.consultation_type || 'N/A'}</td>
//                   <td className="p-2 border">{appt.formattedDate}</td>
//                   <td className="p-2 border">{appt.time_slot || 'N/A'}</td>
//                   <td className="p-2 border font-medium">₹{appt.payable_amount || '0'}</td>
//                   <td className="p-2 border">
//                     <span className={`px-2 py-1 rounded-full text-xs ${appt.status === 'Completed' ? 'bg-purple-100 text-purple-800' : appt.status === 'Confirmed' ? 'bg-green-100 text-green-800' : appt.status === 'Cancelled' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'}`}>
//                       {appt.status || 'N/A'}
//                     </span>
//                    </td>
//                   <td className="p-2 border">
//                     <div className="flex flex-wrap gap-1">
//                       <button onClick={() => navigate(`/appointment/${appt.appointmentId}`)} className="text-blue-600 hover:text-blue-800 p-1" title="View"><FaEye /></button>
//                       <button onClick={() => { setEditAppointment(appt); setNewStatus(appt.status); }} className="text-yellow-600 hover:text-yellow-800 p-1" title="Edit"><FaEdit /></button>
//                       <button onClick={() => handleDelete(appt.appointmentId)} className="text-red-600 hover:text-red-800 p-1" title="Delete"><FaTrash /></button>
//                     </div>
//                   </td>
//                   <td className="p-2 border">
//                     <button onClick={() => openReportModal(appt.appointmentId)} className="text-green-600 hover:text-green-800 p-1"><FaUpload /></button>
//                     {(() => { const r = appt.doctorReports; if (!r) return null; const url = Array.isArray(r) ? (r[0]?.url || r[0]) : (typeof r === 'object' ? r.url : r); return url ? <a href={url} target="_blank" rel="noopener noreferrer" className="ml-1 text-blue-500 text-xs">Download</a> : null; })()}
//                   </td>
//                   <td className="p-2 border">
//                     <button onClick={() => openPrescriptionModal(appt.appointmentId)} className="text-indigo-600 hover:text-indigo-800 p-1"><FaUpload /></button>
//                     {(() => { const p = appt.doctorPrescriptions; if (!p) return null; const url = Array.isArray(p) ? (p[0]?.url || p[0]) : (typeof p === 'object' ? p.url : p); return url ? <a href={url} target="_blank" rel="noopener noreferrer" className="ml-1 text-blue-500 text-xs">Download</a> : null; })()}
//                   </td>
//                   <td className="p-2 border">
//                     {appt.consultation_type === "Online" ? (
//                       appt.meeting_link && appt.meeting_link.trim() !== "" ? (
//                         <a href={appt.meeting_link} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline text-xs">Join</a>
//                       ) : (
//                         <button onClick={() => openMeetingLinkModal(appt.appointmentId)} className="text-green-600 hover:text-green-800 text-xs border rounded px-1">Add Link</button>
//                       )
//                     ) : <span className="text-gray-400">—</span>}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="15" className="p-4 text-center text-gray-500">No appointments found</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {filteredAppointments.length > 0 && (
//         <div className="flex flex-wrap justify-between items-center mt-4 gap-2">
//           <div className="text-sm text-gray-600">Showing {indexOfFirstAppointment + 1} to {Math.min(indexOfLastAppointment, filteredAppointments.length)} of {filteredAppointments.length} entries</div>
//           <div className="flex gap-2">
//             <button onClick={() => setCurrentPage(currentPage - 1)} className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50" disabled={currentPage === 1}>Previous</button>
//             <div className="flex items-center px-4">Page {currentPage} of {totalPages}</div>
//             <button onClick={() => setCurrentPage(currentPage + 1)} className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50" disabled={currentPage === totalPages}>Next</button>
//           </div>
//         </div>
//       )}

//       {/* Modals (unchanged) */}
//       {editAppointment && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white p-6 rounded shadow-md w-96 max-w-[90vw]">
//             <h3 className="text-lg font-semibold mb-4">Update Appointment Status</h3>
//             <div className="mb-4"><label className="block text-sm font-medium mb-1">Current Status:</label><div className="p-2 bg-gray-100 rounded">{editAppointment.status}</div></div>
//             <div className="mb-4"><label className="block text-sm font-medium mb-1">New Status:</label><select className="w-full p-2 border rounded" value={newStatus} onChange={(e) => setNewStatus(e.target.value)}><option value="Confirmed">Confirmed</option><option value="Completed">Completed</option><option value="Cancelled">Cancelled</option><option value="Pending">Pending</option><option value="Accepted">Accepted</option><option value="Rejected">Rejected</option></select></div>
//             <div className="mb-4"><label className="block text-sm font-medium mb-1">Staff Information:</label><div className="p-2 bg-gray-100 rounded">{editAppointment.staff_name} (Employee ID: {editAppointment.staff_employeeId || 'N/A'})</div></div>
//             <div className="flex justify-end gap-2"><button onClick={() => setEditAppointment(null)} className="px-4 py-2 bg-gray-300 rounded">Cancel</button><button onClick={handleStatusUpdate} className="px-4 py-2 bg-blue-600 text-white rounded">Update Status</button></div>
//           </div>
//         </div>
//       )}

//       {showReportModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white p-6 rounded shadow-md w-96 max-w-[90vw]">
//             <h3 className="text-lg font-semibold mb-4">Upload Doctor Report</h3>
//             <div className="mb-4">
//               <div onClick={() => triggerFileInput('report')} className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100">
//                 {selectedFile ? (
//                   <div className="relative w-full h-full p-4"><p className="text-sm font-medium truncate">{selectedFile.name}</p><button type="button" onClick={(e) => { e.stopPropagation(); setSelectedFile(null); setFileInputKey(Date.now()); }} className="absolute top-2 right-2 bg-white rounded-full p-1 shadow-md"><FiX className="text-red-500" /></button></div>
//                 ) : (
//                   <div className="flex flex-col items-center justify-center pt-5 pb-6"><FiUploadCloud className="w-8 h-8 mb-3 text-gray-400" /><p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to upload</span> or drag and drop</p><p className="text-xs text-gray-500">PDF, DOC, DOCX (MAX. 5MB)</p></div>
//                 )}
//                 <input key={`report-${fileInputKey}`} type="file" ref={reportFileInputRef} onChange={handleFileChange} className="hidden" accept=".pdf,.doc,.docx" />
//               </div>
//             </div>
//             <div className="flex justify-end gap-2"><button onClick={() => { setShowReportModal(false); setSelectedFile(null); setFileInputKey(Date.now()); }} className="px-4 py-2 bg-gray-300 rounded">Cancel</button><button onClick={handleUploadReport} className="px-4 py-2 bg-green-600 text-white rounded flex items-center gap-2" disabled={uploading || !selectedFile}>{uploading ? "Uploading..." : "Upload"}{uploading && <span className="animate-spin">⏳</span>}</button></div>
//           </div>
//         </div>
//       )}

//       {showMeetingLinkModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded shadow max-w-md w-full max-w-[90vw]"><h2 className="text-lg font-semibold mb-4">Add Meeting Link</h2><input type="text" value={newMeetingLink} onChange={(e) => setNewMeetingLink(e.target.value)} placeholder="Enter meeting link URL" className="w-full border rounded p-2 mb-4" /><div className="flex justify-end gap-2"><button onClick={closeMeetingLinkModal} className="px-4 py-2 bg-gray-300 rounded">Cancel</button><button onClick={handleMeetingLinkSubmit} className="px-4 py-2 bg-green-600 text-white rounded">Save</button></div></div>
//         </div>
//       )}

//       {showDownloadModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white p-6 rounded shadow-md w-96 max-w-[90vw]">
//             <h3 className="text-lg font-semibold mb-4">Download Files by Date Range</h3>
//             <div className="mb-4"><label className="block text-sm font-medium mb-2">Select Type:</label><select className="w-full p-2 border rounded" value={downloadType} onChange={(e) => setDownloadType(e.target.value)}><option value="">Select File Type</option><option value="reports">Medical Reports</option><option value="prescriptions">Prescriptions</option></select></div>
//             <div className="mb-4"><label className="block text-sm font-medium mb-2">Start Date:</label><input type="date" className="w-full p-2 border rounded" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//             <div className="mb-4"><label className="block text-sm font-medium mb-2">End Date:</label><input type="date" className="w-full p-2 border rounded" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             <div className="flex justify-end gap-2"><button onClick={() => setShowDownloadModal(false)} className="px-4 py-2 bg-gray-300 rounded">Cancel</button><button onClick={handleBulkDownloadModal} disabled={!downloadType || !startDate || !endDate || isDownloading} className="px-4 py-2 bg-green-600 text-white rounded disabled:bg-gray-400">{isDownloading ? "Downloading..." : "Download Zip"}</button></div>
//           </div>
//         </div>
//       )}

//       {showPrescriptionModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white p-6 rounded shadow-md w-96 max-w-[90vw]">
//             <h3 className="text-lg font-semibold mb-4">Upload Doctor Prescription</h3>
//             <div className="mb-4">
//               <div onClick={() => triggerFileInput('prescription')} className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100">
//                 {selectedFile ? (
//                   <div className="relative w-full h-full p-4"><p className="text-sm font-medium truncate">{selectedFile.name}</p><button type="button" onClick={(e) => { e.stopPropagation(); setSelectedFile(null); setFileInputKey(Date.now()); }} className="absolute top-2 right-2 bg-white rounded-full p-1 shadow-md"><FiX className="text-red-500" /></button></div>
//                 ) : (
//                   <div className="flex flex-col items-center justify-center pt-5 pb-6"><FiUploadCloud className="w-8 h-8 mb-3 text-gray-400" /><p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to upload</span> or drag and drop</p><p className="text-xs text-gray-500">PDF, DOC, DOCX (MAX. 5MB)</p></div>
//                 )}
//                 <input key={`prescription-${fileInputKey}`} type="file" ref={prescriptionFileInputRef} onChange={handleFileChange} className="hidden" accept=".pdf,.doc,.docx" />
//               </div>
//             </div>
//             <div className="flex justify-end gap-2"><button onClick={() => { setShowPrescriptionModal(false); setSelectedFile(null); setFileInputKey(Date.now()); }} className="px-4 py-2 bg-gray-300 rounded">Cancel</button><button onClick={handleUploadPrescription} className="px-4 py-2 bg-indigo-600 text-white rounded flex items-center gap-2" disabled={uploading || !selectedFile}>{uploading ? "Uploading..." : "Upload"}{uploading && <span className="animate-spin">⏳</span>}</button></div>
//           </div>
//         </div>
//       )}

//       {/* Bulk Upload Modal (server-side) */}
//       {bulkUploadModal.show && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white p-6 rounded shadow-md w-[500px] max-w-[90vw]">
//             <h3 className="text-lg font-semibold mb-4">
//               Bulk Upload {bulkUploadModal.type === 'report' ? 'Reports' : 'Prescriptions'} for {selectedAppointments.length} selected appointment(s)
//             </h3>
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-2">Upload Type</label>
//               <select
//                 className="w-full p-2 border rounded text-sm mb-3"
//                 value={bulkUploadModal.type}
//                 onChange={(e) => setBulkUploadModal(prev => ({ ...prev, type: e.target.value }))}
//               >
//                 <option value="report">Reports</option>
//                 <option value="prescription">Prescriptions</option>
//               </select>

//               <label className="block text-sm font-medium mb-2">Select ZIP File</label>
//               <input
//                 type="file"
//                 id="bulk-zip-input"
//                 accept=".zip"
//                 onChange={handleBulkZipChange}
//                 className="w-full p-2 border rounded text-sm"
//               />
//               <p className="text-xs text-gray-500 mt-2">
//                 <strong>Note:</strong> Each file inside the ZIP must be named exactly as the <strong>Booking ID</strong> shown in the table (e.g., <code>DOC12345.pdf</code>).<br />
//                 Only files matching your selected appointments will be uploaded (backend will match by ID).
//               </p>
//             </div>

//             {bulkUploadModal.uploading && (
//               <div className="mb-3">
//                 <div className="flex justify-between text-sm mb-1">
//                   <span>Uploading...</span>
//                 </div>
//                 <div className="w-full bg-gray-200 rounded-full h-2.5">
//                   <div className="bg-purple-600 h-2.5 rounded-full animate-pulse w-full"></div>
//                 </div>
//               </div>
//             )}

//             {bulkUploadModal.results && (
//               <div className="mb-3">
//                 <div className="text-sm">✅ Successful: {bulkUploadModal.results.success} / {bulkUploadModal.results.total}</div>
//                 {bulkUploadModal.results.failed.length > 0 && (
//                   <div className="mt-2 max-h-32 overflow-auto text-xs border rounded p-2 bg-red-50">
//                     <p className="font-semibold">Failed files:</p>
//                     {bulkUploadModal.results.failed.map((f, idx) => (
//                       <div key={idx} className="text-red-600">📄 {f.file} - {f.reason}</div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             )}

//             <div className="flex justify-end gap-2 mt-4">
//               <button
//                 onClick={closeBulkUploadModal}
//                 className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
//                 disabled={bulkUploadModal.uploading}
//               >
//                 Cancel
//               </button>
//               {!bulkUploadModal.uploading && (
//                 <button
//                   onClick={handleBulkUpload}
//                   disabled={!bulkUploadModal.file}
//                   className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-purple-300"
//                 >
//                   Start Upload
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DoctorAppointmentList;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaFileExcel, FaEdit, FaTrash, FaEye, FaUpload, FaCalendarAlt, FaFilter, FaDownload, FaInfoCircle, FaEnvelope } from "react-icons/fa";
import { FiUploadCloud, FiX } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import JSZip from "jszip";

const DoctorAppointmentList = () => {
  const [appointments, setAppointments] = useState([]);
  const [search, setSearch] = useState("");
  const [editAppointment, setEditAppointment] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [showReportModal, setShowReportModal] = useState(false);
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [currentAppointmentId, setCurrentAppointmentId] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const navigate = useNavigate();

  // Date filter states
  const [dateFilter, setDateFilter] = useState("all");
  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");
  const [showDateFilter, setShowDateFilter] = useState(false);

  // Bulk download states
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [downloadType, setDownloadType] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState({ done: 0, total: 0, currentFile: "" });

  // Selection states
  const [selectedAppointments, setSelectedAppointments] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Bulk upload modal (server-side)
  const [bulkUploadModal, setBulkUploadModal] = useState({
    show: false,
    type: 'report',
    file: null,
    uploading: false,
    results: null,
    sendEmail: false   // ✅ NEW: email notification toggle
  });

  // Instructions modal state
  const [showInstructionsModal, setShowInstructionsModal] = useState(false);

  const reportFileInputRef = React.useRef(null);
  const prescriptionFileInputRef = React.useRef(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const appointmentsPerPage = 5;

  useEffect(() => {
    fetchAppointments();
  }, []);

  useEffect(() => {
    setSelectedAppointments([]);
    setSelectAll(false);
    setCurrentPage(1);
  }, [search, dateFilter, customStartDate, customEndDate]);

  const fetchAppointments = async () => {
    try {
      const res = await axios.get("https://api.elthiumhealth.com/api/admin/alldoctorbookings");
      if (res.data && res.data.appointments) {
        const formattedAppointments = res.data.appointments.map(appt => ({
          ...appt,
          formattedDate: formatDate(appt.appointment_date)
        }));
        setAppointments(formattedAppointments);
      }
    } catch (error) {
      console.error("Failed to fetch doctor appointments:", error);
    }
  };

  const getBookingId = (appt) => {
    return appt.doctorConsultationBookingId || appt.appointmentId?.toString() || "N/A";
  };

  const handleSelectAppointment = (appointmentId) => {
    setSelectedAppointments(prev =>
      prev.includes(appointmentId) ? prev.filter(id => id !== appointmentId) : [...prev, appointmentId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedAppointments([]);
    } else {
      const currentPageIds = currentAppointments.map(appt => appt.appointmentId);
      setSelectedAppointments(currentPageIds);
    }
    setSelectAll(!selectAll);
  };

  const handleStatusUpdate = async () => {
    try {
      const res = await axios.put(
        `https://api.elthiumhealth.com/api/admin/updatestatus/${editAppointment.appointmentId}`,
        { newStatus: newStatus }
      );
      if (res.status === 200) {
        fetchAppointments();
        setEditAppointment(null);
        setNewStatus("");
      }
    } catch (error) {
      console.error("Failed to update appointment status:", error);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this appointment?");
    if (!confirmDelete) return;
    try {
      await axios.delete(`https://api.elthiumhealth.com/api/admin/deleteappointments/${id}`);
      setAppointments(appointments.filter((a) => a.appointmentId !== id));
      alert("Appointment deleted successfully.");
    } catch (error) {
      console.error("Failed to delete appointment:", error);
      alert("Failed to delete appointment. Please try again.");
    }
  };

  const handleFileChange = (e) => setSelectedFile(e.target.files[0]);

  const handleUploadReport = async () => {
    if (!selectedFile) return alert("Please select a file first");
    setUploading(true);
    const formData = new FormData();
    formData.append("report", selectedFile);
    try {
      const res = await axios.post(
        `https://api.elthiumhealth.com/api/admin/upload-doctor-report/${currentAppointmentId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (res.status === 200) {
        alert("Report uploaded successfully");
        fetchAppointments();
        setShowReportModal(false);
        setSelectedFile(null);
        setFileInputKey(Date.now());
      }
    } catch (error) {
      console.error("Error uploading report:", error);
      alert("Failed to upload report");
    } finally {
      setUploading(false);
    }
  };

  const handleUploadPrescription = async () => {
    if (!selectedFile) return alert("Please select a file first");
    setUploading(true);
    const formData = new FormData();
    formData.append("prescription", selectedFile);
    try {
      const res = await axios.post(
        `https://api.elthiumhealth.com/api/admin/upload-doctor-prescription/${currentAppointmentId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (res.status === 200) {
        alert("Prescription uploaded successfully");
        fetchAppointments();
        setShowPrescriptionModal(false);
        setSelectedFile(null);
        setFileInputKey(Date.now());
      }
    } catch (error) {
      console.error("Error uploading prescription:", error);
      alert("Failed to upload prescription");
    } finally {
      setUploading(false);
    }
  };

  // Date helpers
  const isToday = (dateString) => {
    if (!dateString) return false;
    const today = new Date();
    const date = new Date(dateString);
    return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
  };
  const isYesterday = (dateString) => {
    if (!dateString) return false;
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const date = new Date(dateString);
    return date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();
  };
  const isThisMonth = (dateString) => {
    if (!dateString) return false;
    const today = new Date();
    const date = new Date(dateString);
    return date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
  };
  const isInDateRange = (dateString, startDate, endDate) => {
    if (!dateString || !startDate || !endDate) return false;
    const date = new Date(dateString);
    const start = new Date(startDate);
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    return date >= start && date <= end;
  };

  const filterByDate = (appt) => {
    if (dateFilter === "all") return true;
    if (dateFilter === "today") return isToday(appt.appointment_date);
    if (dateFilter === "yesterday") return isYesterday(appt.appointment_date);
    if (dateFilter === "thisMonth") return isThisMonth(appt.appointment_date);
    if (dateFilter === "custom") return isInDateRange(appt.appointment_date, customStartDate, customEndDate);
    return true;
  };

  const filteredAppointments = appointments
    .filter(filterByDate)
    .filter((appt) => {
      const searchTerm = search.toLowerCase();
      return (
        appt.doctor_name?.toLowerCase()?.includes(searchTerm) ||
        appt.staff_name?.toLowerCase()?.includes(searchTerm) ||
        appt.staff_employeeId?.toLowerCase()?.includes(searchTerm) ||
        appt.doctorConsultationBookingId?.toLowerCase()?.includes(searchTerm) ||
        appt.patient_name?.toLowerCase()?.includes(searchTerm)
      );
    });

  const indexOfLastAppointment = currentPage * appointmentsPerPage;
  const indexOfFirstAppointment = indexOfLastAppointment - appointmentsPerPage;
  const currentAppointments = filteredAppointments.slice(indexOfFirstAppointment, indexOfLastAppointment);
  const totalPages = Math.ceil(filteredAppointments.length / appointmentsPerPage);

  const exportToExcel = () => {
    const dataToExport = filteredAppointments.map(appt => ({
      "Booking ID": getBookingId(appt),
      "Doctor": appt.doctor_name || 'N/A',
      "Specialization": appt.doctor_specialization || 'N/A',
      "User": appt.staff_name || 'N/A',
      "Employee ID": appt.staff_employeeId || 'N/A',
      "Type": appt.consultation_type || 'N/A',
      "Date": appt.formattedDate || 'N/A',
      "Time": appt.time_slot || 'N/A',
      "Paid": `₹${appt.payable_amount || '0'}`,
      "Status": appt.status || 'N/A',
      "Report": appt.doctorReports ? 'Yes' : 'No',
      "Prescription": appt.doctorPrescriptions ? 'Yes' : 'No',
      "Meeting Link": appt.meeting_link ? 'Yes' : 'No'
    }));
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    worksheet['!cols'] = [
      { wch: 12 }, { wch: 18 }, { wch: 18 }, { wch: 12 }, { wch: 12 },
      { wch: 8 }, { wch: 10 }, { wch: 10 }, { wch: 8 }, { wch: 10 },
      { wch: 8 }, { wch: 10 }, { wch: 12 }
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Appointments");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    saveAs(blob, "doctor_appointments.xlsx");
  };

  const formatDate = (dateString) => {
    try {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Invalid date";
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    } catch {
      return "Invalid date";
    }
  };

  const openReportModal = (appointmentId) => {
    setCurrentAppointmentId(appointmentId);
    setShowReportModal(true);
    setSelectedFile(null);
    setFileInputKey(Date.now());
  };

  const openPrescriptionModal = (appointmentId) => {
    setCurrentAppointmentId(appointmentId);
    setShowPrescriptionModal(true);
    setSelectedFile(null);
    setFileInputKey(Date.now());
  };

  const triggerFileInput = (type) => {
    if (type === 'report') reportFileInputRef.current.click();
    else if (type === 'prescription') prescriptionFileInputRef.current.click();
  };

  const countAppointmentsByDateFilter = (filterType) => {
    if (filterType === "all") return appointments.length;
    if (filterType === "today") return appointments.filter(a => isToday(a.appointment_date)).length;
    if (filterType === "yesterday") return appointments.filter(a => isYesterday(a.appointment_date)).length;
    if (filterType === "thisMonth") return appointments.filter(a => isThisMonth(a.appointment_date)).length;
    if (filterType === "custom") return appointments.filter(a => isInDateRange(a.appointment_date, customStartDate, customEndDate)).length;
    return 0;
  };

  const handleCustomDateSelect = () => {
    if (customStartDate && customEndDate) setDateFilter("custom");
  };

  useEffect(() => {
    if (dateFilter !== "custom") {
      setCustomStartDate("");
      setCustomEndDate("");
    }
  }, [dateFilter]);

  const [showMeetingLinkModal, setShowMeetingLinkModal] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [newMeetingLink, setNewMeetingLink] = useState("");

  const openMeetingLinkModal = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setNewMeetingLink("");
    setShowMeetingLinkModal(true);
  };
  const closeMeetingLinkModal = () => {
    setShowMeetingLinkModal(false);
    setSelectedAppointmentId(null);
    setNewMeetingLink("");
  };
  const handleMeetingLinkSubmit = async () => {
    if (!newMeetingLink.trim()) return alert("Please enter a valid meeting link.");
    try {
      const response = await fetch(`https://api.elthiumhealth.com/api/admin/updatemeetinglink/${selectedAppointmentId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ meeting_link: newMeetingLink.trim() }),
      });
      if (!response.ok) throw new Error("Failed to update meeting link");
      alert("Meeting link updated successfully!");
      closeMeetingLinkModal();
      fetchAppointments();
    } catch (error) {
      alert("Error updating meeting link: " + error.message);
    }
  };

  // Bulk download (date-range) – unchanged
  const bulkDownload = async (type) => {
    if (!customStartDate || !customEndDate) {
      alert("Please select a start and end date for the booking date range first.");
      return;
    }
    const apptsInRange = appointments.filter(a => isInDateRange(a.appointment_date, customStartDate, customEndDate));
    if (!apptsInRange.length) {
      alert("No appointments found in the selected date range.");
      return;
    }
    const zip = new JSZip();
    const filesToFetch = [];
    const extractUrls = (field) => {
      if (!field) return [];
      if (typeof field === "string") return [field];
      if (Array.isArray(field)) {
        return field.flatMap(item => {
          if (!item) return [];
          if (typeof item === "string") return [item];
          if (typeof item === "object") return [item.url || item.file || item.path || item.location].filter(Boolean);
          return [];
        });
      }
      if (typeof field === "object") return [field.url || field.file || field.path || field.location].filter(Boolean);
      return [];
    };
    for (const appt of apptsInRange) {
      const bookingId = getBookingId(appt);
      if (type === "report" || type === "both") {
        const reportUrls = extractUrls(appt.doctorReports);
        reportUrls.forEach((url, idx) => {
          filesToFetch.push({ url, filename: `${bookingId}_report_${idx + 1}${getFileExtensionFromUrl(url)}` });
        });
      }
      if (type === "prescription" || type === "both") {
        const presUrls = extractUrls(appt.doctorPrescriptions);
        presUrls.forEach((url, idx) => {
          filesToFetch.push({ url, filename: `${bookingId}_prescription_${idx + 1}${getFileExtensionFromUrl(url)}` });
        });
      }
    }
    if (!filesToFetch.length) {
      alert("No files found for the selected type(s) in this date range.");
      return;
    }
    setDownloading(true);
    setDownloadProgress({ done: 0, total: filesToFetch.length, currentFile: "" });
    let done = 0;
    for (const fileObj of filesToFetch) {
      const { url, filename } = fileObj;
      setDownloadProgress(p => ({ ...p, currentFile: filename }));
      try {
        const response = await fetch(url);
        if (!response.ok) {
          zip.file(`${filename}.ERROR.txt`, `Failed to fetch: ${url}\nStatus: ${response.status}`);
        } else {
          const blob = await response.blob();
          zip.file(filename, blob);
        }
      } catch (err) {
        zip.file(`${filename}.ERROR.txt`, `Error: ${err.message}`);
      }
      done++;
      setDownloadProgress(p => ({ ...p, done }));
    }
    try {
      const outName = `doctor_${type}_${customStartDate}_to_${customEndDate}.zip`;
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, outName);
    } catch (err) {
      alert("Failed to create ZIP: " + err.message);
    } finally {
      setDownloading(false);
      setDownloadProgress({ done: 0, total: 0, currentFile: "" });
    }
  };

  function getFileExtensionFromUrl(url) {
    try {
      const parsed = url.split("?")[0].split("#")[0];
      const lastDot = parsed.lastIndexOf(".");
      if (lastDot === -1) return ".bin";
      const ext = parsed.slice(lastDot);
      return ext.length > 1 && ext.length <= 6 ? ext : ".bin";
    } catch {
      return ".bin";
    }
  }

  const handleBulkDownloadModal = () => {
    if (!downloadType || !startDate || !endDate) return;
    setIsDownloading(true);
    (async () => {
      try {
        const zip = new JSZip();
        const filteredAppointments = appointments.filter(appt => {
          const appointmentDate = new Date(appt.appointment_date);
          const start = new Date(startDate);
          const end = new Date(endDate);
          end.setHours(23, 59, 59);
          return appointmentDate >= start && appointmentDate <= end;
        });
        let fileCount = 0;
        for (const appt of filteredAppointments) {
          const files = downloadType === "reports" ? appt.doctorReports : appt.doctorPrescriptions;
          if (files && files.length) {
            for (let i = 0; i < files.length; i++) {
              try {
                const response = await axios.get(`https://api.elthiumhealth.com${files[i]}`, { responseType: 'blob' });
                const fileName = `${appt.staff_name}_${downloadType.slice(0, -1)}_${i+1}_${appt.appointment_date}.pdf`;
                zip.file(fileName, response.data);
                fileCount++;
              } catch (error) {
                console.error(`Failed to download: ${files[i]}`, error);
              }
            }
          }
        }
        if (fileCount > 0) {
          const content = await zip.generateAsync({ type: "blob" });
          saveAs(content, `${downloadType}_${startDate}_to_${endDate}.zip`);
          alert(`✅ ${fileCount} files downloaded!`);
        } else {
          alert("❌ No files found.");
        }
      } catch (error) {
        console.error("Download failed:", error);
        alert("❌ Download failed.");
      } finally {
        setIsDownloading(false);
        setShowDownloadModal(false);
      }
    })();
  };

  // ==================== BULK UPLOAD (SERVER-SIDE) with EMAIL TOGGLE ====================
  const openBulkUploadModal = () => {
    if (selectedAppointments.length === 0) {
      alert("Please select at least one appointment to upload files.");
      return;
    }
    setBulkUploadModal({
      show: true,
      type: 'report',
      file: null,
      uploading: false,
      results: null,
      sendEmail: false   // ✅ default to false
    });
  };

  const handleBulkZipChange = (e) => {
    const file = e.target.files[0];
    if (file && file.name.endsWith('.zip')) {
      setBulkUploadModal(prev => ({ ...prev, file }));
    } else {
      alert('Please select a valid ZIP file');
      e.target.value = '';
    }
  };

  const handleBulkUpload = async () => {
    if (!bulkUploadModal.file) return alert('Please select a ZIP file first');

    setBulkUploadModal(prev => ({ ...prev, uploading: true, results: null }));

    const formData = new FormData();
    formData.append('zipFile', bulkUploadModal.file);
    const sendMailParam = bulkUploadModal.sendEmail ? 'true' : 'false';
    const endpoint = `https://api.elthiumhealth.com/api/admin/bulk-upload-doctor?type=${bulkUploadModal.type}&sendMail=${sendMailParam}`;

    try {
      const response = await axios.post(endpoint, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (response.data.success) {
        setBulkUploadModal(prev => ({
          ...prev,
          uploading: false,
          results: response.data.results
        }));
        alert(`Bulk upload finished!\nSuccessful: ${response.data.results.success}\nFailed: ${response.data.results.failed.length}`);
        if (response.data.results.success > 0) fetchAppointments();
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      console.error("Bulk upload error:", error);
      setBulkUploadModal(prev => ({
        ...prev,
        uploading: false,
        results: { total: 1, success: 0, failed: [{ file: 'ZIP', reason: error.message }] }
      }));
      alert("Error during bulk upload. Check console.");
    } finally {
      document.getElementById('bulk-zip-input').value = '';
    }
  };

  const closeBulkUploadModal = () => {
    setBulkUploadModal({
      show: false,
      type: 'report',
      file: null,
      uploading: false,
      results: null,
      sendEmail: false
    });
  };
  // ==================== END BULK UPLOAD ====================

  return (
    <div className="p-4 bg-white rounded shadow">
      {/* Header */}
      <div className="flex flex-wrap justify-between items-center gap-2 mb-4">
        <h2 className="text-xl font-semibold">Doctor Appointments</h2>
        <div className="flex gap-2">
          <button
            onClick={() => setShowInstructionsModal(true)}
            className="px-4 py-2 bg-gray-500 text-white rounded text-sm flex items-center gap-2 hover:bg-gray-600"
            title="Bulk Upload Instructions"
          >
            <FaInfoCircle /> Instructions
          </button>
          <button
            onClick={openBulkUploadModal}
            className="px-4 py-2 bg-purple-600 text-white rounded text-sm flex items-center gap-2 hover:bg-purple-700"
          >
            <FaUpload /> Bulk Upload ({selectedAppointments.length})
          </button>
        </div>
      </div>

      {/* Instructions Modal */}
      {showInstructionsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-md w-[600px] max-w-[90vw] max-h-[80vh] overflow-auto">
            <h3 className="text-lg font-semibold mb-4">📋 Bulk Upload Instructions</h3>
            <div className="space-y-3 text-sm">
              <div className="bg-blue-50 p-3 rounded">
                <p className="font-semibold text-blue-800">Step 1: Select Appointments</p>
                <p>✅ Use the checkboxes in the table to select the appointments for which you want to upload reports or prescriptions.</p>
              </div>
              <div className="bg-blue-50 p-3 rounded">
                <p className="font-semibold text-blue-800">Step 2: Prepare ZIP File</p>
                <p>📦 Create a ZIP file containing all the files you want to upload.</p>
                <p className="mt-1"><strong>⚠️ Important:</strong> Each file inside the ZIP must be named exactly as the <strong>Booking ID</strong> shown in the table (e.g., <code>DOC12345.pdf</code> or <code>DOC12345.jpg</code>).</p>
                <p className="mt-1">Supported file types: PDF, DOC, DOCX, JPG, JPEG, PNG.</p>
              </div>
              <div className="bg-blue-50 p-3 rounded">
                <p className="font-semibold text-blue-800">Step 3: Upload</p>
                <p>🔘 Click on <strong>"Bulk Upload"</strong> button (it shows the number of selected appointments).</p>
                <p>🔘 In the popup, choose the type (<strong>Reports</strong> or <strong>Prescriptions</strong>).</p>
                <p>🔘 Select your prepared ZIP file.</p>
                <p>🔘 <strong>Optional:</strong> Check "Send email notifications" to notify patients that their document has been uploaded.</p>
                <p>🔘 Click <strong>"Start Upload"</strong>.</p>
              </div>
              <div className="bg-blue-50 p-3 rounded">
                <p className="font-semibold text-blue-800">Step 4: Monitor Progress</p>
                <p>⏳ The upload will start. You will see a progress bar and a final summary of successful and failed files.</p>
                <p>📁 After successful upload, the table will refresh and you will see the uploaded files (Download links appear).</p>
              </div>
              <div className="bg-yellow-50 p-3 rounded">
                <p className="font-semibold text-yellow-800">💡 Tips:</p>
                <ul className="list-disc list-inside space-y-1">
                  <li>Only files that match the Booking ID of a <strong>selected appointment</strong> will be uploaded.</li>
                  <li>If a file name does not match any selected appointment, it will be skipped and shown in the failed list.</li>
                  <li>You can upload reports and prescriptions separately – use the type selector in the modal.</li>
                  <li>Maximum ZIP size depends on server configuration (typically 20-50 MB).</li>
                </ul>
              </div>
            </div>
            <div className="flex justify-end mt-4">
              <button
                onClick={() => setShowInstructionsModal(false)}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Date Filter Section */}
      <div className="mb-4 p-4 bg-gray-50 rounded-lg">
        <div className="flex justify-between items-center mb-3 flex-wrap gap-2">
          <h3 className="font-medium flex items-center gap-2">
            <FaFilter className="text-blue-500" /> Filter Appointments by Date
          </h3>
          <button
            onClick={() => setShowDateFilter(!showDateFilter)}
            className="px-3 py-1 bg-gray-200 rounded text-sm flex items-center gap-1"
          >
            <FaCalendarAlt /> {showDateFilter ? 'Hide Filters' : 'Show Filters'}
          </button>
        </div>
        {showDateFilter && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
            <div className={`p-3 rounded cursor-pointer text-center ${dateFilter === "all" ? "bg-blue-100 border border-blue-300" : "bg-white border"}`} onClick={() => setDateFilter("all")}>
              <div className="font-semibold">All</div>
              <div className="text-sm text-gray-600">{countAppointmentsByDateFilter("all")} appointments</div>
            </div>
            <div className={`p-3 rounded cursor-pointer text-center ${dateFilter === "today" ? "bg-blue-100 border border-blue-300" : "bg-white border"}`} onClick={() => setDateFilter("today")}>
              <div className="font-semibold">Today</div>
              <div className="text-sm text-gray-600">{countAppointmentsByDateFilter("today")} appointments</div>
            </div>
            <div className={`p-3 rounded cursor-pointer text-center ${dateFilter === "yesterday" ? "bg-blue-100 border border-blue-300" : "bg-white border"}`} onClick={() => setDateFilter("yesterday")}>
              <div className="font-semibold">Yesterday</div>
              <div className="text-sm text-gray-600">{countAppointmentsByDateFilter("yesterday")} appointments</div>
            </div>
            <div className={`p-3 rounded cursor-pointer text-center ${dateFilter === "thisMonth" ? "bg-blue-100 border border-blue-300" : "bg-white border"}`} onClick={() => setDateFilter("thisMonth")}>
              <div className="font-semibold">This Month</div>
              <div className="text-sm text-gray-600">{countAppointmentsByDateFilter("thisMonth")} appointments</div>
            </div>
            <div className={`p-3 rounded text-center ${dateFilter === "custom" ? "bg-blue-100 border border-blue-300" : "bg-white border"}`}>
              <div className="font-semibold mb-2">Custom Range</div>
              <div className="flex flex-col gap-2">
                <input type="date" className="text-sm p-1 border rounded" value={customStartDate} onChange={(e) => setCustomStartDate(e.target.value)} onClick={() => setDateFilter("custom")} />
                <input type="date" className="text-sm p-1 border rounded" value={customEndDate} onChange={(e) => setCustomEndDate(e.target.value)} onClick={() => setDateFilter("custom")} />
                <div className="flex gap-2">
                  <button className="text-xs bg-blue-500 text-white py-1 rounded" onClick={handleCustomDateSelect}>Apply</button>
                  <button className="text-xs bg-gray-200 text-gray-800 py-1 rounded" onClick={() => { setCustomStartDate(""); setCustomEndDate(""); setDateFilter("all"); }}>Clear</button>
                </div>
              </div>
            </div>
          </div>
        )}
        {dateFilter === "custom" && customStartDate && customEndDate && (
          <div className="mt-3 text-sm text-blue-600">Showing appointments from {customStartDate} to {customEndDate}: {countAppointmentsByDateFilter("custom")} appointments</div>
        )}
        <div className="mt-3 flex flex-wrap gap-2 items-center">
          <button onClick={() => bulkDownload("report")} className="px-3 py-2 bg-green-600 text-white rounded text-sm" disabled={downloading || !customStartDate || !customEndDate}>Download Reports (ZIP)</button>
          <button onClick={() => bulkDownload("prescription")} className="px-3 py-2 bg-indigo-600 text-white rounded text-sm" disabled={downloading || !customStartDate || !customEndDate}>Download Prescriptions (ZIP)</button>
          <button onClick={() => bulkDownload("both")} className="px-3 py-2 bg-blue-600 text-white rounded text-sm" disabled={downloading || !customStartDate || !customEndDate}>Download Both (ZIP)</button>
          {downloading && <div className="ml-4 text-sm text-gray-700">Downloading {downloadProgress.done}/{downloadProgress.total} — {downloadProgress.currentFile}</div>}
        </div>
      </div>

      {/* Search and Export */}
      <div className="mb-4 flex flex-wrap gap-2">
        <input type="text" className="px-3 py-2 border rounded text-sm flex-grow min-w-[200px]" placeholder="Search by doctor name, ID, user or employee ID..." value={search} onChange={(e) => setSearch(e.target.value)} />
        <button onClick={() => setShowDownloadModal(true)} className="px-4 py-2 bg-purple-500 text-white rounded text-sm flex items-center gap-1 hover:bg-purple-600"><FaDownload /> Bulk Download</button>
        <button onClick={exportToExcel} className="px-4 py-2 bg-green-600 text-white rounded text-sm flex items-center gap-1"><FaFileExcel /> Export</button>
      </div>

      {/* Table - compact column widths */}
      <div className="overflow-x-auto">
        <table className="w-full border rounded text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border text-center w-8">
                <input type="checkbox" checked={selectAll} onChange={handleSelectAll} className="h-4 w-4 cursor-pointer" />
              </th>
              <th className="p-2 border text-left w-24">Booking ID</th>
              <th className="p-2 border text-left w-28">Doctor</th>
              <th className="p-2 border text-left w-28">Specialization</th>
              <th className="p-2 border text-left w-20">User</th>
              <th className="p-2 border text-left w-20">Emp ID</th>
              <th className="p-2 border text-left w-16">Type</th>
              <th className="p-2 border text-left w-24">Date</th>
              <th className="p-2 border text-left w-16">Time</th>
              <th className="p-2 border text-left w-12">Paid</th>
              <th className="p-2 border text-left w-20">Status</th>
              <th className="p-2 border text-left w-16">Actions</th>
              <th className="p-2 border text-left w-16">Report</th>
              <th className="p-2 border text-left w-20">Prescription</th>
              <th className="p-2 border text-left w-24">Meeting Link</th>
            </tr>
          </thead>
          <tbody>
            {currentAppointments.length > 0 ? (
              currentAppointments.map((appt) => (
                <tr key={appt.appointmentId} className="hover:bg-gray-50 border-b">
                  <td className="p-2 border text-center">
                    <input
                      type="checkbox"
                      checked={selectedAppointments.includes(appt.appointmentId)}
                      onChange={() => handleSelectAppointment(appt.appointmentId)}
                      className="h-4 w-4 cursor-pointer"
                    />
                  </td>
                  <td className="p-2 border truncate max-w-[120px]" title={getBookingId(appt)}>{getBookingId(appt)}</td>
                  <td className="p-2 border truncate max-w-[140px]" title={appt.doctor_name}>{appt.doctor_name || 'Doctor'}</td>
                  <td className="p-2 border truncate max-w-[140px]" title={appt.doctor_specialization}>{appt.doctor_specialization || 'N/A'}</td>
                  <td className="p-2 border truncate max-w-[100px]" title={appt.staff_name}>{appt.staff_name}</td>
                  <td className="p-2 border">{appt.staff_employeeId || 'null'}</td>
                  <td className="p-2 border">{appt.consultation_type || 'N/A'}</td>
                  <td className="p-2 border">{appt.formattedDate}</td>
                  <td className="p-2 border">{appt.time_slot || 'N/A'}</td>
                  <td className="p-2 border font-medium">₹{appt.payable_amount || '0'}</td>
                  <td className="p-2 border">
                    <span className={`px-2 py-1 rounded-full text-xs ${appt.status === 'Completed' ? 'bg-purple-100 text-purple-800' : appt.status === 'Confirmed' ? 'bg-green-100 text-green-800' : appt.status === 'Cancelled' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'}`}>
                      {appt.status || 'N/A'}
                    </span>
                    </td>
                  <td className="p-2 border">
                    <div className="flex flex-wrap gap-1">
                      <button onClick={() => navigate(`/appointment/${appt.appointmentId}`)} className="text-blue-600 hover:text-blue-800 p-1" title="View"><FaEye /></button>
                      <button onClick={() => { setEditAppointment(appt); setNewStatus(appt.status); }} className="text-yellow-600 hover:text-yellow-800 p-1" title="Edit"><FaEdit /></button>
                      <button onClick={() => handleDelete(appt.appointmentId)} className="text-red-600 hover:text-red-800 p-1" title="Delete"><FaTrash /></button>
                    </div>
                   </td>
                  <td className="p-2 border">
                    <button onClick={() => openReportModal(appt.appointmentId)} className="text-green-600 hover:text-green-800 p-1"><FaUpload /></button>
                    {(() => { const r = appt.doctorReports; if (!r) return null; const url = Array.isArray(r) ? (r[0]?.url || r[0]) : (typeof r === 'object' ? r.url : r); return url ? <a href={url} target="_blank" rel="noopener noreferrer" className="ml-1 text-blue-500 text-xs">Download</a> : null; })()}
                   </td>
                  <td className="p-2 border">
                    <button onClick={() => openPrescriptionModal(appt.appointmentId)} className="text-indigo-600 hover:text-indigo-800 p-1"><FaUpload /></button>
                    {(() => { const p = appt.doctorPrescriptions; if (!p) return null; const url = Array.isArray(p) ? (p[0]?.url || p[0]) : (typeof p === 'object' ? p.url : p); return url ? <a href={url} target="_blank" rel="noopener noreferrer" className="ml-1 text-blue-500 text-xs">Download</a> : null; })()}
                   </td>
                  <td className="p-2 border">
                    {appt.consultation_type === "Online" ? (
                      appt.meeting_link && appt.meeting_link.trim() !== "" ? (
                        <a href={appt.meeting_link} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline text-xs">Join</a>
                      ) : (
                        <button onClick={() => openMeetingLinkModal(appt.appointmentId)} className="text-green-600 hover:text-green-800 text-xs border rounded px-1">Add Link</button>
                      )
                    ) : <span className="text-gray-400">—</span>}
                   </td>
                 </tr>
              ))
            ) : (
              <tr>
                <td colSpan="15" className="p-4 text-center text-gray-500">No appointments found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {filteredAppointments.length > 0 && (
        <div className="flex flex-wrap justify-between items-center mt-4 gap-2">
          <div className="text-sm text-gray-600">Showing {indexOfFirstAppointment + 1} to {Math.min(indexOfLastAppointment, filteredAppointments.length)} of {filteredAppointments.length} entries</div>
          <div className="flex gap-2">
            <button onClick={() => setCurrentPage(currentPage - 1)} className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50" disabled={currentPage === 1}>Previous</button>
            <div className="flex items-center px-4">Page {currentPage} of {totalPages}</div>
            <button onClick={() => setCurrentPage(currentPage + 1)} className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50" disabled={currentPage === totalPages}>Next</button>
          </div>
        </div>
      )}

      {/* Modals (unchanged except bulk upload modal) */}
      {editAppointment && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-md w-96 max-w-[90vw]">
            <h3 className="text-lg font-semibold mb-4">Update Appointment Status</h3>
            <div className="mb-4"><label className="block text-sm font-medium mb-1">Current Status:</label><div className="p-2 bg-gray-100 rounded">{editAppointment.status}</div></div>
            <div className="mb-4"><label className="block text-sm font-medium mb-1">New Status:</label><select className="w-full p-2 border rounded" value={newStatus} onChange={(e) => setNewStatus(e.target.value)}><option value="Confirmed">Confirmed</option><option value="Completed">Completed</option><option value="Cancelled">Cancelled</option><option value="Pending">Pending</option><option value="Accepted">Accepted</option><option value="Rejected">Rejected</option></select></div>
            <div className="mb-4"><label className="block text-sm font-medium mb-1">Staff Information:</label><div className="p-2 bg-gray-100 rounded">{editAppointment.staff_name} (Employee ID: {editAppointment.staff_employeeId || 'N/A'})</div></div>
            <div className="flex justify-end gap-2"><button onClick={() => setEditAppointment(null)} className="px-4 py-2 bg-gray-300 rounded">Cancel</button><button onClick={handleStatusUpdate} className="px-4 py-2 bg-blue-600 text-white rounded">Update Status</button></div>
          </div>
        </div>
      )}

      {showReportModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-md w-96 max-w-[90vw]">
            <h3 className="text-lg font-semibold mb-4">Upload Doctor Report</h3>
            <div className="mb-4">
              <div onClick={() => triggerFileInput('report')} className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100">
                {selectedFile ? (
                  <div className="relative w-full h-full p-4"><p className="text-sm font-medium truncate">{selectedFile.name}</p><button type="button" onClick={(e) => { e.stopPropagation(); setSelectedFile(null); setFileInputKey(Date.now()); }} className="absolute top-2 right-2 bg-white rounded-full p-1 shadow-md"><FiX className="text-red-500" /></button></div>
                ) : (
                  <div className="flex flex-col items-center justify-center pt-5 pb-6"><FiUploadCloud className="w-8 h-8 mb-3 text-gray-400" /><p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to upload</span> or drag and drop</p><p className="text-xs text-gray-500">PDF, DOC, DOCX (MAX. 5MB)</p></div>
                )}
                <input key={`report-${fileInputKey}`} type="file" ref={reportFileInputRef} onChange={handleFileChange} className="hidden" accept=".pdf,.doc,.docx" />
              </div>
            </div>
            <div className="flex justify-end gap-2"><button onClick={() => { setShowReportModal(false); setSelectedFile(null); setFileInputKey(Date.now()); }} className="px-4 py-2 bg-gray-300 rounded">Cancel</button><button onClick={handleUploadReport} className="px-4 py-2 bg-green-600 text-white rounded flex items-center gap-2" disabled={uploading || !selectedFile}>{uploading ? "Uploading..." : "Upload"}{uploading && <span className="animate-spin">⏳</span>}</button></div>
          </div>
        </div>
      )}

      {showMeetingLinkModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow max-w-md w-full max-w-[90vw]"><h2 className="text-lg font-semibold mb-4">Add Meeting Link</h2><input type="text" value={newMeetingLink} onChange={(e) => setNewMeetingLink(e.target.value)} placeholder="Enter meeting link URL" className="w-full border rounded p-2 mb-4" /><div className="flex justify-end gap-2"><button onClick={closeMeetingLinkModal} className="px-4 py-2 bg-gray-300 rounded">Cancel</button><button onClick={handleMeetingLinkSubmit} className="px-4 py-2 bg-green-600 text-white rounded">Save</button></div></div>
        </div>
      )}

      {showDownloadModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-md w-96 max-w-[90vw]">
            <h3 className="text-lg font-semibold mb-4">Download Files by Date Range</h3>
            <div className="mb-4"><label className="block text-sm font-medium mb-2">Select Type:</label><select className="w-full p-2 border rounded" value={downloadType} onChange={(e) => setDownloadType(e.target.value)}><option value="">Select File Type</option><option value="reports">Medical Reports</option><option value="prescriptions">Prescriptions</option></select></div>
            <div className="mb-4"><label className="block text-sm font-medium mb-2">Start Date:</label><input type="date" className="w-full p-2 border rounded" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
            <div className="mb-4"><label className="block text-sm font-medium mb-2">End Date:</label><input type="date" className="w-full p-2 border rounded" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
            <div className="flex justify-end gap-2"><button onClick={() => setShowDownloadModal(false)} className="px-4 py-2 bg-gray-300 rounded">Cancel</button><button onClick={handleBulkDownloadModal} disabled={!downloadType || !startDate || !endDate || isDownloading} className="px-4 py-2 bg-green-600 text-white rounded disabled:bg-gray-400">{isDownloading ? "Downloading..." : "Download Zip"}</button></div>
          </div>
        </div>
      )}

      {showPrescriptionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-md w-96 max-w-[90vw]">
            <h3 className="text-lg font-semibold mb-4">Upload Doctor Prescription</h3>
            <div className="mb-4">
              <div onClick={() => triggerFileInput('prescription')} className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100">
                {selectedFile ? (
                  <div className="relative w-full h-full p-4"><p className="text-sm font-medium truncate">{selectedFile.name}</p><button type="button" onClick={(e) => { e.stopPropagation(); setSelectedFile(null); setFileInputKey(Date.now()); }} className="absolute top-2 right-2 bg-white rounded-full p-1 shadow-md"><FiX className="text-red-500" /></button></div>
                ) : (
                  <div className="flex flex-col items-center justify-center pt-5 pb-6"><FiUploadCloud className="w-8 h-8 mb-3 text-gray-400" /><p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to upload</span> or drag and drop</p><p className="text-xs text-gray-500">PDF, DOC, DOCX (MAX. 5MB)</p></div>
                )}
                <input key={`prescription-${fileInputKey}`} type="file" ref={prescriptionFileInputRef} onChange={handleFileChange} className="hidden" accept=".pdf,.doc,.docx" />
              </div>
            </div>
            <div className="flex justify-end gap-2"><button onClick={() => { setShowPrescriptionModal(false); setSelectedFile(null); setFileInputKey(Date.now()); }} className="px-4 py-2 bg-gray-300 rounded">Cancel</button><button onClick={handleUploadPrescription} className="px-4 py-2 bg-indigo-600 text-white rounded flex items-center gap-2" disabled={uploading || !selectedFile}>{uploading ? "Uploading..." : "Upload"}{uploading && <span className="animate-spin">⏳</span>}</button></div>
          </div>
        </div>
      )}

      {/* Bulk Upload Modal with Email Toggle */}
      {bulkUploadModal.show && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-md w-[550px] max-w-[90vw]">
            <h3 className="text-lg font-semibold mb-4">
              Bulk Upload {bulkUploadModal.type === 'report' ? 'Reports' : 'Prescriptions'} for {selectedAppointments.length} selected appointment(s)
            </h3>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">Upload Type</label>
              <select
                className="w-full p-2 border rounded text-sm mb-3"
                value={bulkUploadModal.type}
                onChange={(e) => setBulkUploadModal(prev => ({ ...prev, type: e.target.value }))}
              >
                <option value="report">Reports</option>
                <option value="prescription">Prescriptions</option>
              </select>

              <label className="block text-sm font-medium mb-2">Select ZIP File</label>
              <input
                type="file"
                id="bulk-zip-input"
                accept=".zip"
                onChange={handleBulkZipChange}
                className="w-full p-2 border rounded text-sm"
              />
              <p className="text-xs text-gray-500 mt-2">
                <strong>Note:</strong> Each file inside the ZIP must be named exactly as the <strong>Booking ID</strong> shown in the table (e.g., <code>DOC12345.pdf</code>).<br />
                Only files matching your selected appointments will be uploaded (backend will match by ID).
              </p>

              {/* ✅ Email Notification Toggle */}
              <div className="mt-4 flex items-center gap-3 p-3 bg-gray-50 rounded border">
                <input
                  type="checkbox"
                  id="sendEmailCheckbox"
                  checked={bulkUploadModal.sendEmail}
                  onChange={(e) => setBulkUploadModal(prev => ({ ...prev, sendEmail: e.target.checked }))}
                  className="w-4 h-4 text-purple-600 rounded focus:ring-purple-500"
                />
                <label htmlFor="sendEmailCheckbox" className="text-sm font-medium text-gray-700 flex items-center gap-2 cursor-pointer">
                  <FaEnvelope className="text-purple-600" />
                  Send email notifications to users
                </label>
              </div>
              {bulkUploadModal.sendEmail && (
                <p className="text-xs text-green-600 mt-1">
                  ✅ Emails will be sent to the users whose documents are successfully uploaded.
                </p>
              )}
            </div>

            {bulkUploadModal.uploading && (
              <div className="mb-3">
                <div className="flex justify-between text-sm mb-1">
                  <span>Uploading...</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                  <div className="bg-purple-600 h-2.5 rounded-full animate-pulse w-full"></div>
                </div>
              </div>
            )}

            {bulkUploadModal.results && (
              <div className="mb-3">
                <div className="text-sm">✅ Successful: {bulkUploadModal.results.success} / {bulkUploadModal.results.total}</div>
                {bulkUploadModal.results.failed.length > 0 && (
                  <div className="mt-2 max-h-32 overflow-auto text-xs border rounded p-2 bg-red-50">
                    <p className="font-semibold">Failed files:</p>
                    {bulkUploadModal.results.failed.map((f, idx) => (
                      <div key={idx} className="text-red-600">📄 {f.file} - {f.reason}</div>
                    ))}
                  </div>
                )}
              </div>
            )}

            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={closeBulkUploadModal}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                disabled={bulkUploadModal.uploading}
              >
                Cancel
              </button>
              {!bulkUploadModal.uploading && (
                <button
                  onClick={handleBulkUpload}
                  disabled={!bulkUploadModal.file}
                  className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-purple-300"
                >
                  Start Upload
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DoctorAppointmentList;